import { FC } from 'react';
import { Box, Button, Typography, CircularProgress } from '@mui/material';
import ReusableModal from '../common/Modal';
import { IconProps } from '@phosphor-icons/react';

interface ConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
  title?: string;
  description?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  icon?: React.FC<IconProps>;
  confirmButtonColor?: 'primary' | 'error' | 'warning' | 'success';
  backgroundColor?: string;
}

const ConfirmationModal: FC<ConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  isPending,
  title = 'Confirm Action',
  description = 'Are you sure you want to proceed with this action?',
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
  icon: Icon,
  confirmButtonColor = 'primary',
  backgroundColor = 'rgba(25, 118, 210, 0.15)',
}) => {
  return (
    <ReusableModal
      open={open}
      onClose={onClose}
      title={title}
      width={500}
      backgroundColor={backgroundColor}
    >
      <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column' }}>
        <Typography
          fontSize={14}
          fontWeight={400}
          lineHeight={1.5}
          letterSpacing={-0.14}
          color="text.secondary"
        >
          {description}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 2,
            mt: 2,
            pt: 2,
            borderTop: '1px solid #DCE0E7',
          }}
        >
          <Button
            onClick={onClose}
            sx={{
              textTransform: 'none',
              borderRadius: '6px',
              flex: 1,
              color: 'custom.textBlue',
              fontWeight: 500,
              fontSize: '14px',
            }}
          >
            {cancelButtonText}
          </Button>

          <Button
            variant="contained"
            color={confirmButtonColor}
            onClick={onConfirm}
            startIcon={
              isPending ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                Icon && <Icon size={16} />
              )
            }
            disabled={isPending}
            sx={{
              textTransform: 'none',
              borderRadius: '6px',
              flex: 1,
              boxShadow: 'none',
            }}
          >
            {isPending ? 'Processing...' : confirmButtonText}
          </Button>
        </Box>
      </Box>
    </ReusableModal>
  );
};

export default ConfirmationModal;
